import React, {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";
import BaseFieldComponent from "../BaseFieldComponent";
import ButtonText from "../../../../connectui/component/input/button/ButtonText";
import ListingSelectorMenu from "../../shared/context/ListingSelectorMenu";
import OutlinedButtonBase from "../../../../connectui/component/input/button/base/OutlinedButtonBase";
import {getHouses} from "../../../../redux/actions/listingsActions";
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";

const ListingField = ({
  fieldData,
  handleValueChange,
  options,
  reducer,
  ...props
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIds, setSelectedIds] = useState(fieldData?.val || []);
  const listings_dict = reducer.house_data_dict;
  const dispatch = useDispatch();
  const fetchingListings = useRef({});
  const menuSelectionsRef = useRef(new Set());
  const {t} = useTranslation();
  const fetchListingIfNeeded = (listingIds) => {
    const idsToProcess = Array.isArray(listingIds)
      ? listingIds
      : listingIds
        ? [listingIds]
        : [];

    idsToProcess.forEach((id) => {
      if (id && !listings_dict[id] && !fetchingListings.current[id]) {
        fetchingListings.current[id] = true;
        dispatch(getHouses(`listing_id=${id}`, true));
      }
    });
  };

  useEffect(() => {
    fetchListingIfNeeded(fieldData?.val);
  }, [fieldData?.val, listings_dict]);

  const handleFilterChange = (newSelection) => {
    handleValueChange(
      "custom",
      !!newSelection.length
        ? [{path: fieldData.field, value: newSelection}]
        : [],
    );
  };

  const handleOpenMenu = (e) => {
    setAnchorEl(e.currentTarget);
    menuSelectionsRef.current = new Set();
  };

  const handleListingSelection = (listing_id, isSelected) => {
    let newSelection;

    if (isSelected) {
      newSelection = selectedIds.filter((id) => id !== listing_id);
    } else {
      newSelection = [...selectedIds, listing_id];

      if (!menuSelectionsRef.current.has(listing_id)) {
        menuSelectionsRef.current.add(listing_id);
        fetchListingIfNeeded(listing_id);
      }
    }

    setSelectedIds(newSelection);
    handleFilterChange(newSelection);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const renderFilter = () => (
    <>
      <ButtonText
        buttonBase={OutlinedButtonBase}
        label={t("listing-field-select-listings")}
        onClick={handleOpenMenu}
      />
      <ListingSelectorMenu
        open={!!anchorEl}
        onClose={handleMenuClose}
        anchorEl={anchorEl}
        selectedIds={selectedIds}
        onListingSelection={handleListingSelection}
        listingFilters={[]}
      />
    </>
  );

  const getOperators = () => [
    "contains",
    "not_contains",
    "exists",
    "not_exists",
    "is_one_of",
  ];

  const getLabel = () => {
    const currentVal = fieldData?.val;

    if (Array.isArray(currentVal)) {
      const names = currentVal
        .map((id) => listings_dict[id]?.nickname || id)
        .join(", ");

      return names;
    } else {
      const id = currentVal;

      if (listings_dict[id]) {
        return (
          listings_dict[id]?.nickname || listings_dict[id]?.name || "loading..."
        );
      }

      return "loading...";
    }
  };

  return (
    <BaseFieldComponent
      renderInput={() => null}
      renderFilter={renderFilter}
      getLabel={getLabel}
      getOperators={getOperators}
      {...props}
    />
  );
};

ListingField.propTypes = {
  fieldData: PropTypes.object.isRequired,
  handleValueChange: PropTypes.func.isRequired,
  reducer: PropTypes.object.isRequired,
};

export default ListingField;
